export const tableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "Campo de Análisis",
                    type: 'text',
                    key: 'field',

                },
                {
                    title: "Nombre y Apellido",
                    type: 'text',
                    key: 'name',

                },
                {
                    title: "Calificación",
                    type: 'text',
                    key: 'qualification',

                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}